module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1515-21b52ec67d1a9f93e7e9c472807c44c6.png";